import styled, { css, keyframes } from 'styled-components';

import { getCDNImageUrl } from '@/helpers/cdn';

import { device } from '@/styles/helpers';

const shine = getCDNImageUrl('/lootbox/shine.webp');

export interface ScLootboxItemProps {
  isSelected: boolean;
  isChoiceMade: boolean;
}

const rotateAnimation = keyframes`
    0% { transform: rotate(0); }
    100% { transform: rotate(360deg); }
`;

export const ScLootboxItem = styled.div<ScLootboxItemProps>`
  width: 156px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: visible;
  gap: 12px;

  & > .bonus {
    font-weight: 700;
    font-size: 22px;
    line-height: 1.27;
    text-align: center;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.whiteColor};
    word-break: break-word;
  }

  & > .empty-text {
    font-weight: 700;
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
    letter-spacing: 0.01em;
  }

  & > .button-container {
    position: absolute;
    bottom: 0;
    z-index: 3;
    display: none;
    width: 100%;
  }

  ${({ isChoiceMade }) =>
    !isChoiceMade &&
    css`
      &::before {
        content: '';
        position: absolute;
        inset: -24px;
        background: url(${shine});
        background-size: 100%;
        background-repeat: no-repeat;
        animation: ${rotateAnimation} 2s infinite linear;
        z-index: -1;
        opacity: 0;
        transition: 0.4s;
      }
    `}

  ${({ isSelected, isChoiceMade }) =>
    !isSelected &&
    isChoiceMade &&
    css`
      opacity: 0.4;
    `}

  &:hover {
    &::before {
      opacity: 1;
    }
    & > .button-container {
      display: block;
    }
  }

  .mobile-click-wrapper {
    pointer-events: none;
  }

  @media (hover: none) {
    object {
      pointer-events: none;
    }

    .mobile-click-wrapper {
      pointer-events: all;
    }
  }

  @media (${device.mobile}) {
    width: 144px;

    & > .empty-text {
      font-size: 14px;
      line-height: 1.43;
    }
  }
`;
